import { render, staticRenderFns } from "./DeleteCohortIconDialog.vue?vue&type=template&id=07311e8a&scoped=true"
import script from "./DeleteCohortIconDialog.vue?vue&type=script&lang=js"
export * from "./DeleteCohortIconDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07311e8a",
  null
  
)

export default component.exports